export default {
    FollowOrUnfollow: 'Chọn/ Bỏ chọn tất cả',
};
